import {
  ChangePasswordDto,
  ForgotPasswordRequest,
  RegisterRequest,
  ResetPasswordDto,
} from "@models";
import requests from "./agent";

export const accountService = {
  changePassword: async (request: ChangePasswordDto) => {
    await requests.post("/api/services/app/User/ChangePassword", request);
  },

  register: async (request: RegisterRequest) => {
    await requests.post("/api/Account/Register", request);
  },

  activate: async (confirmation: string) => {
    await requests.post("/api/Account/Activate", { confirmation });
  },
  sendPasswordResetCode: async (request: ForgotPasswordRequest) => {
    await requests.post("/api/Account/SendPasswordResetCode", request);
  },

  resetPassword: async (input: ResetPasswordDto) => {
    await requests.post("/api/Account/ResetPassword", input);
  },
};
